import * as React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";

import { filterCareerData, getCareerOfSelectedYear, getSelectedYearTotal, percentageFormat, getIndicator,ColorLookup } from "./CTSAReportHelper";
import CareerYearSlider from "./CareerYearSlider";
import "./CommonChart.css";
interface Props {
    compareGroup?: string[];
    careerData?: {}[];
}

interface State {
    selectedYear: number
}

class CareerChart extends React.Component<Props, State> {
    state = { selectedYear: 1 }


    handleYearChange = n => {
        this.setState({ selectedYear: n });
    };
    render() {


        const { compareGroup, careerData } = this.props;
        const { selectedYear } = this.state;
   
        const selectedYearData = getCareerOfSelectedYear(careerData, selectedYear);
        const barData = filterCareerData(careerData, selectedYear, compareGroup);
        const { KL2Indicator, KCOMPIndicator } = getIndicator(selectedYearData, compareGroup);

            return (
                < div className="chart-container">
                    <h4 className="chart-title">Ongoing Career in Research</h4>
                    <CareerYearSlider onChange={this.handleYearChange} />
                    <p className="chart-title">Job Title {selectedYear} Year(s) after K Award Start Date</p>
                    <div className="svg-container">
                        <BarChart
                            width={900}
                            height={350}
                            data={barData}
                        >
                            
                            <CartesianGrid strokeDasharray="3 3" vertical={false}/>
                            
                            <XAxis dataKey="occ" tick={{fontSize: 16}} />
                            <YAxis
                                label={{ value: "Percentage", position: "insideLeft", angle: -90, offset: 5, fontSize: 16 }}
                                tick={{ fontSize: 16 }}
                                tickFormatter={tick => `${tick}%`}
                            />
                            <Tooltip formatter={percentageFormat} />
                            <Legend layout="vertical" align='right' verticalAlign="middle" wrapperStyle={{ right: '-30px' }} width={200} iconSize={20}/>
                            {['KL2', ...compareGroup].map(award => <Bar dataKey={award} key={award} fill={ColorLookup[award]} name={`${award} (n=${getSelectedYearTotal(selectedYearData, award)})`} />)}
                        </BarChart>
                    </div>
                    <p style={{ paddingLeft: '25px', paddingTop: '25px' }}>A key indicator of an ongoing research career is job title, specifically tenure track faculty and research faculty.
This chart displays the most recent job title of K scholars. Use the slider to display data by number of years following the
completion of the K award.</p>
                    <ul>
                        <li>{percentageFormat(KL2Indicator)} of KL2 scholars held job titles indicative of an ongoing research career</li>
                        <li>{percentageFormat(KCOMPIndicator)} of K comparison scholars held job titles indicative of an ongoing research career</li>

                    </ul>
                </div >
            );
    }
}

export default CareerChart;

